module.exports = __webpack_public_path__ + "static/media/sembawang.28b0d9d8.png";